export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";